module.exports = __webpack_public_path__ + "img/eyein-partner-nuclias.65efa277.webp";